import { render, staticRenderFns } from "./mrp-yxjd-add.vue?vue&type=template&id=2ff623b8&scoped=true"
import script from "./mrp-yxjd-add.vue?vue&type=script&lang=js"
export * from "./mrp-yxjd-add.vue?vue&type=script&lang=js"
import style0 from "./mrp-yxjd-add.vue?vue&type=style&index=0&id=2ff623b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff623b8",
  null
  
)

export default component.exports